import React from 'react';
import { Section } from './ui';
export const Story = () => {
  return <Section className="bg-brand-cream" data-id="element-190">
      <div className="text-center mb-10" data-id="element-191">
        <img src="https://images.unsplash.com/photo-1556910103-1c02745aae4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Nata Hernández" className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover mx-auto mb-5 shadow-md border-4 border-white" data-id="element-192" />
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold mb-3 leading-tight" data-id="element-193">
          El descubrimiento que lo cambió todo
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 font-medium" data-id="element-194">
          Soy Nata Hernández.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4 text-base sm:text-lg text-gray-700 mb-10 text-center" data-id="element-195">
        <p data-id="element-196">
          Cuando mi hija nació con intolerancia al gluten, hornear dejó de ser
          un hobby.
        </p>
        <p className="font-bold text-lg sm:text-xl" data-id="element-197">Se volvió una misión.</p>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-2xl p-6 md:p-8 text-center max-w-2xl mx-auto mb-12 shadow-sm" data-id="element-198">
        <p className="text-lg sm:text-xl font-bold text-green-800 mb-2" data-id="element-199">
          👉 No necesitas mejores ingredientes.
        </p>
        <p className="text-xl sm:text-2xl font-bold text-green-900 tracking-wide leading-tight" data-id="element-200">
          NECESITAS UNA MEJOR ESTRUCTURA.
        </p>
      </div>

      <div className="text-center mb-10" data-id="element-201">
        <p className="text-base sm:text-xl mb-3" data-id="element-202">Así nació lo que hoy llamo:</p>
        <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-semibold text-brand-violet mb-5 leading-tight" data-id="element-203">
          El Método de Estructura Húmeda™
        </h3>
        <p className="text-base sm:text-lg text-gray-600" data-id="element-204">
          Un sistema simple que controla:
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-205">
        <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-soft text-center border border-gray-100" data-id="element-206">
          <div className="text-4xl mb-3" data-id="element-207">💧</div>
          <p className="font-medium text-base sm:text-lg" data-id="element-208">
            Cómo se activa la humedad
          </p>
        </div>
        <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-soft text-center border border-gray-100" data-id="element-209">
          <div className="text-4xl mb-3" data-id="element-210">↕️</div>
          <p className="font-medium text-base sm:text-lg" data-id="element-211">
            El orden químico de los ingredientes
          </p>
        </div>
        <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-soft text-center border border-gray-100" data-id="element-212">
          <div className="text-4xl mb-3" data-id="element-213">🌡️</div>
          <p className="font-medium text-base sm:text-lg" data-id="element-214">
            La retención de textura en el horno
          </p>
        </div>
      </div>
    </Section>;
};